import './OverallInsights.scss';
import React from 'react';
import { useTranslation } from 'react-i18next';
import CustomTooltip from '../../../../shared/components/common/tooltip/CustomTooltip';

interface OverallInsightsProps {
  overallInsights: string[] | null;
}

const OverallInsights: React.FC<OverallInsightsProps> = ({ overallInsights }) => {
  const { t } = useTranslation();

  if (!overallInsights) {
    return <></>;
  }

  return (
    <div className="stats__panel">
      <div className="page-box__title-action">
        <div className="page-box__title page-box__title--flex">{t('insightPage.overallInsights')}</div>
      </div>
      <div className="stats-box stats-box--list">
        <div className="stats-box__content">
          <ul>
            {overallInsights.map((text) => (
              <li>
                <div className="ico-box">
                  <span className="ico--eye ico--xxs" />
                </div>
                {text}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default OverallInsights;
